export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Body_BaseColor.7b648ae4.tga";